export default "__VITE_ASSET__cd8896b6__"